<div class="main-delete">
  <button class="close-btn" type="button" (click)="cancel()">
    <mat-icon>close</mat-icon>
  </button>

  <div class="text-part">
    <span class="text-part-title">{{ 'fee.delete_group_question' | translate }}</span>
    @if (data.hasData) {
      <span class="text-part-info">{{ 'fee.delete_group_blocked' | translate }}</span>
      <span class="text-part-info">{{ 'fee.delete_group_blocked_hint' | translate }}</span>
    } @else {
      <span class="text-part-info">{{ 'fee.confirm_delete_group' | translate:{ groupName: data.groupName } }}</span>
    }
  </div>

  <div class="action-part">
    <button class="option-cancel option-shared" type="button" (click)="cancel()">{{ 'cancel' | translate }}</button>
    <button class="option-remove option-shared" type="button" [disabled]="deleting || data.hasData" (click)="confirmDelete()">
      {{ 'fee.delete_group' | translate }}
    </button>
  </div>
</div>
